/** The panel's top-level sections, shared by the shell and route tests. */

export interface AdminNavItem {
  labelKey: string;
  path: string;
  testId: string;
}

export const ADMIN_NAV_ITEMS: AdminNavItem[] = [
  {
    labelKey: "shell.navigation.articles",
    path: "/articles",
    testId: "articles",
  },
  { labelKey: "shell.navigation.events", path: "/events", testId: "events" },
  {
    labelKey: "shell.navigation.highlights",
    path: "/dashboard-highlights",
    testId: "dashboard-highlights",
  },
  { labelKey: "shell.navigation.users", path: "/users", testId: "users" },
  { labelKey: "shell.navigation.chat", path: "/chat", testId: "chat" },
  {
    labelKey: "shell.navigation.analytics",
    path: "/analytics",
    testId: "analytics",
  },
];

/** Prefix matching keeps the owning tab selected on detail and create routes. */
export function activeAdminPath(pathname: string): string {
  return (
    ADMIN_NAV_ITEMS.find(
      (item) => pathname === item.path || pathname.startsWith(`${item.path}/`),
    )?.path ?? "/articles"
  );
}
